import React, { ChangeEvent } from "react";
import Card from "../../../runtimeComponent/card";
import { CommentDetail } from "../../../entities/formTemplateDataType";
import CMACommentHeaderComponent from "./CMACommentHeaderComponent";
import { TemplateStatus } from "../../../entities/Constants";

const CMACommentComponent = ({ 
    data, index, newComment, setComment, cmaRole, status, isCommentOwner, deleteComment,
}: { 
    data?: CommentDetail,
    index: number,
    isCommentOwner: boolean,
    newComment?: boolean,
    cmaRole: 'A' | 'C', 
    status?: string,
    setComment: (comment: string, index: number, resolved?: boolean) => void,
    deleteComment: (index: number) => void,
}) => {

    const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>, value: string, index: number) => {
        setComment(value, index, e.target.checked);
    }

    const handleCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setComment(e.target.value ?? '', -1, cmaRole==='C');
    }

    return (
        <>
            {!newComment && (
                <Card className={`notBordered comment-card ${data.Resolved ? 'comment-card-unresolved' : ''}`}
                    header={<CMACommentHeaderComponent 
                        cmaRole={cmaRole}
                        comment={data}
                        index={index} 
                        isCommentOwner={isCommentOwner} 
                        handleComentChange={handleCheckboxChange} 
                        deleteComment={deleteComment}
                    />}
                    content={<div style={{whiteSpace: 'pre-wrap'}}>{data.Comments}</div>}
                />
            )}
            {newComment && (cmaRole==='A' || status===TemplateStatus.REVISION) && (
                <Card className="notBordered"
                    header={'Add a comment'}
                    content={<textarea 
                        placeholder="Adding a comment will reo-open this discussion...." 
                        value={data.Comments} onChange={handleCommentChange}
                        style={{width: '100%', height: '100px', padding: '0.5rem'}}
                    />}
                />
            )}
        </>
    );
}

export default CMACommentComponent;